export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return iOS;
}

export function canPlayBackgroundVideo() {
  return !isIOS();
}